import request from '@/utils/request/api'

//新的文章列表
export function ArticleLists(params: any) {
    return request.get({ url: '/Article/lists', params })
}

//备案指导  去掉params
export function getTypeArticle() {
    return request.get({ url: '/Article/getTypeArticle' })
}

//各个省份的备案规则
export function getAddressRuleInfo() {
    return request.get({ url: '/ArticleAddress/getAddressRuleInfo' })
}

// 新的 文章详情
export function articleDetail(params: any) {
    return request.get({ url: '/Article/detail', params })
}
